import { render, staticRenderFns } from "./ReportByRequest.vue?vue&type=template&id=2b352238&"
import script from "./ReportByRequest.vue?vue&type=script&lang=js&"
export * from "./ReportByRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports